<template>
  <div class="custom-calendar-container">
    <label for="icondisplay" class="font-bold block mb-2"> {{ label }} </label>
    <Calendar
      v-model="selectedDate"
      :dateFormat="dateFormat"
      :showIcon="true"
      :inline="inline"
      :selectionMode="selectionMode"
      iconDisplay="input"
      inputId="icondisplay"
      @date-select="onDateSelect"
    />
  </div>
</template>

<script>
import Calendar from 'primevue/calendar'

export default {
  name: 'CustomCalendar',
  components: { Calendar },
  props: {
    modelValue: {
      type: [Date, String, Array],
      default: null,
    },
    dateFormat: {
      type: String,
      default: 'mm/dd/yy',
    },
    selectionMode: {
      type: String,
      default: 'single',
    },
    inline: {
      type: Boolean,
      default: false,
    },
    label: String,
    onDateSelect: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      selectedDate: this.modelValue,
    }
  },
  watch: {
    modelValue(newValue) {
      this.selectedDate = newValue
    },
    selectedDate(newValue) {
      this.$emit('update:modelValue', newValue)
      if (this.onDateSelect) {
        this.onDateSelect(newValue)
      }
    },
  },
}
</script>
<style scoped>
.custom-calendar-container {
  margin-left: 15px;
  margin-bottom: 25px;
}
.p-inputtext {
  padding: 12px !important;
  border-bottom-left-radius: 12px;
  border-top-left-radius: 12px;
}
.p-calendar {
  height: 45px;
}
</style>
